import type { RestrictivePractice } from '@lmc/validations'
import type { Dayjs } from 'dayjs'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'
import { StepEntryList, useEntryDrawer } from '../../StepEntryCard'
import RestrictivePracticeCard from './RestrictivePracticeCard'
import RestrictivePracticeDrawer from './RestrictivePracticeDrawer'

type RestrictivePracticeListProps = {
  /** Supplied by the form item. */
  value?: Array<RestrictivePractice>
  onChange?: (practices: Array<RestrictivePractice>) => void
  incidentStart: Dayjs
  testId: string
}

/** The practices as cards, each edited in a drawer, and Add below. */
const RestrictivePracticeList = ({
  value = [],
  onChange,
  incidentStart,
  testId
}: RestrictivePracticeListProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)
  const { close, drawer, open, remove, save } = useEntryDrawer<
    RestrictivePractice,
    RestrictivePractice | undefined
  >(value, onChange)

  return (
    <>
      <StepEntryList
        addLabel={t(incidentReportsConstants.CASE_V2_RESTRICTIVE_ADD)}
        addTestId={`${testId}-add`}
        onAdd={() => open(undefined)}
      >
        {value.map((practice, index) => (
          <RestrictivePracticeCard
            // Entries have no id; the list is only ever replaced whole.
            // biome-ignore lint/suspicious/noArrayIndexKey: see above
            key={index}
            practice={practice}
            onEdit={() => open(practice, index)}
            onDelete={() => remove(index)}
            testId={`${testId}-practice-${index}`}
          />
        ))}
      </StepEntryList>
      {drawer && (
        <RestrictivePracticeDrawer
          practice={drawer.entry}
          incidentStart={incidentStart}
          onCancel={close}
          onSave={save}
          testId={`${testId}-drawer`}
        />
      )}
    </>
  )
}

export default RestrictivePracticeList
